import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OrderRefreshService {
  private refreshSubject = new Subject<void>();
  orderRefresh$ = this.refreshSubject.asObservable();

  triggerRefresh(): void {
     console.log('refresh received');
    this.refreshSubject.next();
  }
}
